import {Message} from "./Message";
import {EventParticipant} from "./EventParticipant";
import {UserConnection} from "./UserConnection";

export class ConversationOverview {

  public participants: EventParticipant[] = [];
  public participantIds: string[];

  public unreadCount: number = 0;
  public lastMessage: Message = null;

  constructor(public id: string,
              public status: number = UserConnection.CONNECTION_REQUEST_STATUS_OK) {
  }

  static fromAngularFireSnapshot(snapshot: any) : ConversationOverview {
    return ConversationOverview._fromSnapshot(snapshot.key, snapshot.payload.val());
  }

  private static _fromSnapshot(key: string, {users, lastMessage, status}) : ConversationOverview {
    let conversation = new ConversationOverview(key, status);
    if (lastMessage) {
      conversation.lastMessage = new Message(null, lastMessage.sender, lastMessage.contentType, lastMessage.content, lastMessage.date);
    }
    if (users) {
      conversation.participantIds = Object.keys(users);
    }

    return conversation;
  }
}



// WEBPACK FOOTER //
// ./src/providers/communication/models/ConversationOverview.ts